

<tgrid-layer-header [layer]="this" [additionIcons]="iconConfig()">


      <div class="legend">
        <div class="legend-line">
          <div class="color-dot" [style.background-color]="'#b30000'"></div>
          <span>Proposed</span>
        </div>
        <div class="legend-line">
          <div class="color-dot" [style.background-color]="'#ebdc78'"></div>
          <span>Existing</span>
        </div>
      </div>
</tgrid-layer-header>
